import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { PackageOpen } from 'lucide-react';

// Aviso al vendedor: productos activos sin peso o medidas del paquete.
export const PackageDataNotice = ({ refreshKey, onEdit }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get('/sellers/me/package-data-missing').then(r => setData(r.data)).catch(() => setData(null));
  }, [refreshKey]);
  if (!data?.count) return null;
  return (
    <div className="mt-4 border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900" data-testid="package-data-notice">
      <div className="flex items-center gap-2 font-semibold">
        <PackageOpen className="h-4 w-4" />
        <span data-testid="package-data-notice-count">{data.count}</span> producto(s) activos sin peso o medidas del paquete
      </div>
      <p className="mt-1 text-xs text-amber-800">Complétalos para que los envíos puedan cotizarse con precisión más adelante. Hoy no cambia lo que cobras.</p>
      <div className="mt-2 flex flex-wrap gap-2">
        {data.items.slice(0, 8).map(p => (
          <button key={p.product_id} type="button" onClick={() => onEdit?.(p.product_id)}
            className="border border-amber-300 bg-white px-2 py-0.5 text-xs hover:bg-amber-100" data-testid={`package-data-notice-item-${p.product_id}`}>
            {p.name}
          </button>
        ))}
        {data.count > 8 && <span className="text-xs text-amber-700">y {data.count - 8} más</span>}
      </div>
    </div>
  );
};
